import { useMemo, useState } from 'react';
import { FONT_MONO } from '../theme';
import { Card } from '../ui';
import { CardTitle, EmptyNote, PillGroup } from './common';
import { fmtInt, topFoods } from './nutritionData';

const METRICS = [
  { id: 'kcal', label: 'kcal' },
  { id: 'protein', label: 'Protein' },
];

/* The 8 foods that supply the most kcal or protein over the window, with
 * their share of the total and how often they were logged. */
export function TopFoodsCard({ t, nutrition, from, to, days }) {
  const [metric, setMetric] = useState('kcal');
  const top = useMemo(() => topFoods(nutrition, from, to, metric, 8), [nutrition, from, to, metric]);
  const max = top.rows.length ? top.rows[0].share : 1;

  return (
    <Card t={t} padding={16}>
      <CardTitle t={t} sub={`Last ${days} days, grouped by name`}
        right={<PillGroup t={t} label="Rank foods by" options={METRICS} value={metric} onChange={setMetric} />}>
        Top foods
      </CardTitle>
      {top.rows.length === 0 ? (
        <EmptyNote t={t}>Nothing logged in the last {days} days.</EmptyNote>
      ) : top.rows.map((r, i) => (
        <div key={r.key} style={{ padding: '8px 0', borderTop: i ? `1px solid ${t.divider}` : 'none' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
            <span style={{ fontSize: 11, fontFamily: FONT_MONO, color: t.textFaint, width: 14, flexShrink: 0 }}>{i + 1}</span>
            <span style={{ fontSize: 13, fontWeight: 600, color: t.text, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {r.name}
            </span>
            <span style={{ fontSize: 11, color: t.textFaint, flexShrink: 0 }}>×{r.count}</span>
            <span style={{ fontSize: 13, fontFamily: FONT_MONO, fontWeight: 600, color: t.text, flexShrink: 0, minWidth: 64, textAlign: 'right' }}>
              {metric === 'protein' ? `${fmtInt(r.protein)} g` : fmtInt(r.kcal)}
            </span>
            <span style={{ fontSize: 11, fontFamily: FONT_MONO, color: t.textMuted, flexShrink: 0, width: 34, textAlign: 'right' }}>
              {Math.round(r.share * 100)}%
            </span>
          </div>
          <div style={{ marginLeft: 22, marginTop: 5, height: 3, borderRadius: 2, background: t.surfaceAlt }}>
            <div style={{ width: `${max > 0 ? (r.share / max) * 100 : 0}%`, height: '100%', borderRadius: 2, background: metric === 'protein' ? t.accent : t.textMuted }} />
          </div>
        </div>
      ))}
    </Card>
  );
}
